import { useState } from "react";
import { NavigationContext } from "./navigation-context";

export function NavigationProvider({ children }) {
  const [activeItem, setActiveItem] = useState("dashboard");
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <NavigationContext.Provider
      value={{ activeItem, setActiveItem, isSidebarOpen, setSidebarOpen }}
    >
      {children}
    </NavigationContext.Provider>
  );
}
